import { cn } from '@/lib/utils'

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
  /** Rendered element; `article` for a self-contained item such as an assessment card. */
  as?: 'div' | 'article' | 'section'
}

/** Bordered surface panel — the shell every panel, row, and card sits in. */
export function Card({ as: Comp = 'div', className, children, ...rest }: CardProps) {
  return (
    <Comp className={cn('rounded-card border border-border bg-surface', className)} {...rest}>
      {children}
    </Comp>
  )
}
